module.exports = __webpack_public_path__ + "img/shanchu.65dc2f78.png";